import { render, staticRenderFns } from "./SettingsWorkspacePlatformEdit.vue?vue&type=template&id=0222082e"
import script from "./SettingsWorkspacePlatformEdit.vue?vue&type=script&lang=js"
export * from "./SettingsWorkspacePlatformEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports